import Icon, { IconType } from '@/components/view/atoms/icon/Icon'
import ModuleIcon, { ModuleIconType } from '@/components/view/atoms/icon/ModuleIcon'
import BadgeList from '@/components/view/layouts/badge/BadgeList'
import TitleBadge, { TitleBadgeColor } from '@/components/view/molecules/badge/TitleBadge'

export const AppTitleBadgeType = {
  MASTER: 'master',
  RECOMMEND: 'recommend',
  MEDIA: 'media',
  MEDIA_GEO: 'mediaGeo'
} as const

export type AppTitleBadgeType = (typeof AppTitleBadgeType)[keyof typeof AppTitleBadgeType]

const titleBadgeList = (
  type: AppTitleBadgeType
): {
  title: string
  subTitleIconType: ModuleIconType
  iconType: IconType
  color: TitleBadgeColor
} => {
  switch (type) {
    case 'master':
      return {
        title: 'データ基盤',
        subTitleIconType: ModuleIconType.W2_MASTER,
        iconType: IconType.DATABASE,
        color: 'orange'
      }
    case 'recommend':
      return {
        title: 'AIレコメンド',
        subTitleIconType: ModuleIconType.RECO_MEDIA,
        iconType: IconType.RECOMMEND,
        color: 'sky'
      }
    case 'media':
      return {
        title: 'コンテンツ生成',
        subTitleIconType: ModuleIconType.MEDIA_DRIVER,
        iconType: IconType.RECOMMEND,
        color: 'green'
      }
    case 'mediaGeo':
      return {
        title: 'AI検索最適化',
        subTitleIconType: ModuleIconType.MEDIA_DRIVER,
        iconType: IconType.RECOMMEND,
        color: 'purple'
      }
    default:
      throw new Error('Invalid AppTitleBadgeType')
  }
}

interface Props {
  type: AppTitleBadgeType
}

const AppTitleBadge = ({ type }: Props) => {
  const badges = titleBadgeList(type)

  return (
    <BadgeList>
      <TitleBadge iconType={badges.iconType} color={badges.color}>
        {badges.title}
      </TitleBadge>
      <ModuleIcon type={badges.subTitleIconType} />
    </BadgeList>
  )
}

export default AppTitleBadge
